import { KinoklubCinemaChoices, KinoklubLanguage, KinoklubProgram } from './interfaces/global.js';
import { KinoklubMovie } from './interfaces/movie.interface.js';
import { MovieScraper } from './services/movie.service.js';
import { ProgramScraper } from './services/program.service.js';

export class KinoklubApi {
  constructor(
    private programScraper: ProgramScraper,
    private movieService: MovieScraper
  ) {}

  public async program(
    lang: KinoklubLanguage = 'cs',
    cinemas: KinoklubCinemaChoices[] | number[]
  ): Promise<KinoklubProgram[]> {
    return this.programScraper.program(lang, cinemas);
  }

  public async movie(movie: number, lang: KinoklubLanguage = 'cs'): Promise<KinoklubMovie> {
    return this.movieService.movie(+movie, lang);
  }
}

const programScraper = new ProgramScraper();
const movieScraper = new MovieScraper();
export const kinoklub = new KinoklubApi(programScraper, movieScraper);
export * from './interfaces/index';
